import React from 'react'
import styled from 'styled-components'
import { formatMetricValue } from '../utils/zoningHelpers'
import {
  MetricLabel,
  MetricValueCell,
  EmptyValue,
} from './ZoneMetricsTable.styles'

const RowWithBorder = styled.tr`
  height: 48px;
  td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  }
`

export interface DeterminingAreaRowProps {
  std?: number
  label?: string
}

/**
 * Special row for Determining land area (STd)
 * Always shown first, non-editable, no authorized value
 */
export const DeterminingAreaRow: React.FC<DeterminingAreaRowProps> = ({
  std,
  label = 'Determining land area (STd)',
}) => {
  return (
    <RowWithBorder>
      <td>
        <MetricLabel>{label}</MetricLabel>
      </td>
      <MetricValueCell>
        {std !== undefined ? (
          formatMetricValue(std, 'm²', undefined)
        ) : (
          <EmptyValue>-</EmptyValue>
        )}
      </MetricValueCell>
      <MetricValueCell>
        <EmptyValue>-</EmptyValue>
      </MetricValueCell>
      <MetricValueCell>
        <EmptyValue>-</EmptyValue>
      </MetricValueCell>
    </RowWithBorder>
  )
}
